import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = { class: "form-contents" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_10 = { class: "clearfix" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_12 = { class: "bottom10" };
const _hoisted_13 = { class: "invalid-feedback" };
const _hoisted_14 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_15 = { class: "invalid-feedback" };
const _hoisted_16 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_17 = { class: "clearfix bottom10" };
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_19 = { class: "input-group top_search" };
const _hoisted_20 = { class: "input-group-btn" };
const _hoisted_21 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_22 = { class: "float-end" };
const _hoisted_23 = { class: "clearfix" };
const _hoisted_24 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_25 = { class: "card bg-white data-grid models-grid detached overflow-x-auto" };
const _hoisted_26 = { class: "table table-hover bottom0 pw100" };
const _hoisted_27 = { key: 0 };
const _hoisted_28 = { class: "text-center hidden-sm" };
const _hoisted_29 = { class: "clearfix visible-sm" };
const _hoisted_30 = { key: 0 };
const _hoisted_31 = { key: 0 };
const _hoisted_32 = ["colspan"];
const _hoisted_33 = {
    key: 0,
    class: "clearfix top10"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _component_router_link = _resolveComponent("router-link");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle || 'Missing manufacturer name...'), 1 /* TEXT */)
            ]),
            _cache[10] || (_cache[10] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.save
                    }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "danger",
                        onClick: _ctx.deleteManufacturer
                    }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Delete", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]), [
                        [_vShow, !_ctx.isNewManufacturer]
                    ]),
                    _cache[9] || (_cache[9] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.goBack
                    }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _cache[43] || (_cache[43] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"])
                ]),
                _cache[40] || (_cache[40] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_CollapsibleForm, null, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d;
                            return [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _cache[11] || (_cache[11] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tName *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[12] || (_cache[12] = _createTextVNode()),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.nameVal, {
                                                type: "text",
                                                maxlength: "150",
                                                modelValue: _ctx.manufacturer.manufacturerName,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.manufacturer.manufacturerName) = $event)),
                                                modelModifiers: { trim: true },
                                                class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.name }
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                            _cache[13] || (_cache[13] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_13, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a manufacturer name.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.name]
                                            ])
                                        ]),
                                        _cache[18] || (_cache[18] = _createTextVNode()),
                                        (_ctx.isNewManufacturer && !_ctx.preselectedManufacturerTypeId)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                _cache[15] || (_cache[15] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tType *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[16] || (_cache[16] = _createTextVNode()),
                                                _createVNode(_component_multiselect, _mergeProps(_ctx.manufacturerTypeVal, {
                                                    modelValue: _ctx.manufacturerType,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.manufacturerType) = $event)),
                                                    "track-by": "value",
                                                    label: "text",
                                                    placeholder: _ctx.selectPlaceholder,
                                                    options: _ctx.manufacturerTypes,
                                                    showLabels: false,
                                                    class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.manufacturerType }
                                                }), {
                                                    noResult: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 16 /* FULL_PROPS */, ["modelValue", "placeholder", "options", "class"]),
                                                _cache[17] || (_cache[17] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", _hoisted_15, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please select a manufacturer type\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                    [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.manufacturerType]
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ]),
                _cache[41] || (_cache[41] = _createTextVNode()),
                _createCommentVNode(" Models Section "),
                _cache[42] || (_cache[42] = _createTextVNode()),
                (!_ctx.isNewManufacturer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_CollapsibleForm, { initiallyExpanded: true }, {
                            header: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                    _createElementVNode("h3", null, "Models", -1 /* CACHED */)
                                ]))]),
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: _ctx.modelsQuery.keywords,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.modelsQuery.keywords) = $event)),
                                                modelModifiers: { trim: true },
                                                placeholder: "Search for models...",
                                                onKeyup: _withKeys(_ctx.searchModels, ["enter"]),
                                                required: ""
                                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                                            _cache[21] || (_cache[21] = _createTextVNode()),
                                            _createElementVNode("span", _hoisted_20, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn-default",
                                                    onClick: _cache[3] || (_cache[3] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.searchModels && _ctx.searchModels(...args)))
                                                }, [...(_cache[20] || (_cache[20] = [
                                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                                    ]))])
                                            ])
                                        ])
                                    ]),
                                    _cache[23] || (_cache[23] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, [
                                            _createVNode(_component_router_link, {
                                                to: { name: 'model', params: { 'companyId': _ctx.companyId, 'manufacturerId': _ctx.manufacturerId } }
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_button, { variant: "primary" }, {
                                                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                                _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                                                _createElementVNode("span", { class: "hidden-xs" }, " Add Model", -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["to"])
                                        ])
                                    ])
                                ]),
                                _cache[38] || (_cache[38] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("table", _hoisted_26, [
                                                _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                        _cache[24] || (_cache[24] = _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* CACHED */)),
                                                        _cache[25] || (_cache[25] = _createTextVNode()),
                                                        _createElementVNode("th", null, [
                                                            _createVNode(_component_SortableColumnComponent, {
                                                                sorter: _ctx.modelsSorter,
                                                                column: { fieldName: 'ModelName', title: 'Name' }
                                                            }, null, 8 /* PROPS */, ["sorter"])
                                                        ]),
                                                        _cache[26] || (_cache[26] = _createTextVNode()),
                                                        (_ctx.isBatteryManufacturer)
                                                            ? (_openBlock(), _createElementBlock("th", _hoisted_27, [
                                                                _createVNode(_component_SortableColumnComponent, {
                                                                    sorter: _ctx.modelsSorter,
                                                                    column: { fieldName: 'Price', title: _ctx.getPriceTitle }
                                                                }, null, 8 /* PROPS */, ["sorter", "column"])
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ]),
                                                _cache[35] || (_cache[35] = _createTextVNode()),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelsData.records, (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", null, [
                                                            _createElementVNode("td", _hoisted_28, [
                                                                _createVNode(_component_b_button_group, null, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_b_dropdown, {
                                                                            variant: "outline-secondary dots",
                                                                            size: "sm",
                                                                            onClick: ($event) => (_ctx.editModel(item))
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createVNode(_component_b_dropdown_item, {
                                                                                    onClick: ($event) => (_ctx.editModel(item))
                                                                                }, {
                                                                                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                                                            _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                                            _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                                        ]))]),
                                                                                    _: 1 /* STABLE */
                                                                                }, 8 /* PROPS */, ["onClick"]),
                                                                                _cache[29] || (_cache[29] = _createTextVNode()),
                                                                                _createVNode(_component_b_dropdown_divider),
                                                                                _cache[30] || (_cache[30] = _createTextVNode()),
                                                                                _createVNode(_component_b_dropdown_item, {
                                                                                    onClick: ($event) => (_ctx.deleteModel(item))
                                                                                }, {
                                                                                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                                                            _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                                            _createTextVNode(" Delete\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                                        ]))]),
                                                                                    _: 1 /* STABLE */
                                                                                }, 8 /* PROPS */, ["onClick"])
                                                                            ]),
                                                                            _: 2 /* DYNAMIC */
                                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1024 /* DYNAMIC_SLOTS */)
                                                            ]),
                                                            _cache[32] || (_cache[32] = _createTextVNode()),
                                                            _createElementVNode("td", null, [
                                                                _createVNode(_component_router_link, {
                                                                    to: { name: 'model', params: { 'companyId': _ctx.companyId, 'manufacturerId': _ctx.manufacturerId, 'id': item.modelId } },
                                                                    class: "blue hidden-sm"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(item.modelName), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                                _cache[31] || (_cache[31] = _createTextVNode()),
                                                                _createElementVNode("div", _hoisted_29, [
                                                                    _createVNode(_component_router_link, {
                                                                        to: { name: 'model', params: { 'companyId': _ctx.companyId, 'manufacturerId': _ctx.manufacturerId, 'id': item.modelId } },
                                                                        class: "lead"
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(item.modelName), 1 /* TEXT */)
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                                                ])
                                                            ]),
                                                            _cache[33] || (_cache[33] = _createTextVNode()),
                                                            (_ctx.isBatteryManufacturer)
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(item.price != null ? item.price.toFixed(2) : '-'), 1 /* TEXT */))
                                                                : _createCommentVNode("v-if", true)
                                                        ]));
                                                    }), 256 /* UNKEYED_FRAGMENT */))
                                                ]),
                                                _cache[36] || (_cache[36] = _createTextVNode()),
                                                _createElementVNode("tfoot", null, [
                                                    (_ctx.noModelsData)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                                                            _createElementVNode("td", {
                                                                class: "text-center",
                                                                colspan: _ctx.isBatteryManufacturer ? 3 : 2
                                                            }, [...(_cache[34] || (_cache[34] = [
                                                                    _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no models for this manufacturer.\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                ]))], 8 /* PROPS */, _hoisted_32)
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ]),
                                        _cache[37] || (_cache[37] = _createTextVNode()),
                                        (_ctx.modelsData.recordCount > _ctx.modelsQuery.pageSize)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                _createVNode(_component_b_pagination, {
                                                    modelValue: _ctx.modelsQuery.pageNo,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.modelsQuery.pageNo) = $event)),
                                                    "per-page": _ctx.modelsQuery.pageSize,
                                                    "total-rows": _ctx.modelsData.recordCount,
                                                    "hide-ellipsis": true,
                                                    disabled: _ctx.workingModels
                                                }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]))
                    : _createCommentVNode("v-if", true)
            ])
        ])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
